// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const DownloadFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M50.285 56.949V41.768A2.292 2.292 0 0 0 48 39.469a2.292 2.292 0 0 0-2.285 2.299V56.95l-4.266-4.292a2.275 2.275 0 0 0-3.231 0 2.308 2.308 0 0 0 0 3.25l8.165 8.214a2.273 2.273 0 0 0 1.617.673c.662 0 1.258-.283 1.675-.735l8.107-8.151a2.308 2.308 0 0 0 0-3.25 2.275 2.275 0 0 0-3.23-.001l-4.267 4.29Zm21.528-22.37C82.986 34.578 92 44.09 92 55.786 92 67.482 82.985 77 71.813 77h-50.26C11.836 77 4 68.73 4 58.571c0-9.842 7.352-17.914 16.644-18.41C24.076 28.333 34.484 20 46.516 20c9.952 0 18.91 5.717 23.64 14.647.549-.046 1.102-.069 1.657-.069Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default DownloadFilled;
